'use strict';
import * as $i_$0040ui5$002fwebcomponents$002fdist$002fTitle$002ejs from "@ui5/webcomponents/dist/Title.js";
import * as $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024 from "./com.raquo.laminar.-Dom-Api$.js";
import * as $j_io$002egithub$002enguyenyou$002eui5$002ewebcomponents$002elaminar$002eshared$002e$002dString$002dUnion$002dCodec$0024$0024anon$00241 from "./io.github.nguyenyou.ui5.webcomponents.laminar.shared.-String-Union-Codec$$anon$1.js";
import * as $j_io$002egithub$002enguyenyou$002eui5$002ewebcomponents$002elaminar$002eshared$002e$002dWeb$002dComponent from "./io.github.nguyenyou.ui5.webcomponents.laminar.shared.-Web-Component.js";
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Lio_github_nguyenyou_ui5_webcomponents_laminar_Title$() {
  this.dz = null;
  this.cu = null;
  this.dV = null;
  this.dW = false;
  this.Ir = null;
  this.Is = false;
  $j_io$002egithub$002enguyenyou$002eui5$002ewebcomponents$002elaminar$002eshared$002e$002dWeb$002dComponent.$ct_Lio_github_nguyenyou_ui5_webcomponents_laminar_shared_WebComponent__T__(this, "ui5-title");
}
export { $c_Lio_github_nguyenyou_ui5_webcomponents_laminar_Title$ as $c_Lio_github_nguyenyou_ui5_webcomponents_laminar_Title$ };
$p = $c_Lio_github_nguyenyou_ui5_webcomponents_laminar_Title$.prototype = new $j_io$002egithub$002enguyenyou$002eui5$002ewebcomponents$002elaminar$002eshared$002e$002dWeb$002dComponent.$h_Lio_github_nguyenyou_ui5_webcomponents_laminar_shared_WebComponent();
$p.constructor = $c_Lio_github_nguyenyou_ui5_webcomponents_laminar_Title$;
/** @constructor */
function $h_Lio_github_nguyenyou_ui5_webcomponents_laminar_Title$() {
}
export { $h_Lio_github_nguyenyou_ui5_webcomponents_laminar_Title$ as $h_Lio_github_nguyenyou_ui5_webcomponents_laminar_Title$ };
$h_Lio_github_nguyenyou_ui5_webcomponents_laminar_Title$.prototype = $p;
$p.PA = (function() {
  if ((!this.Is)) {
    this.Ir = ($j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$m_Lcom_raquo_laminar_api_package$(), $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$ct_Lcom_raquo_laminar_keys_HtmlAttr__T__Lcom_raquo_laminar_codecs_Codec__(new $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$c_Lcom_raquo_laminar_keys_HtmlAttr(), "level", new $j_io$002egithub$002enguyenyou$002eui5$002ewebcomponents$002elaminar$002eshared$002e$002dString$002dUnion$002dCodec$0024$0024anon$00241.$c_Lio_github_nguyenyou_ui5_webcomponents_laminar_shared_StringUnionCodec$$anon$1()));
    this.Is = true;
  }
  return this.Ir;
});
$p.cQ = (function() {
  return $i_$0040ui5$002fwebcomponents$002fdist$002fTitle$002ejs.default;
});
var $d_Lio_github_nguyenyou_ui5_webcomponents_laminar_Title$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lio_github_nguyenyou_ui5_webcomponents_laminar_Title$, "io.github.nguyenyou.ui5.webcomponents.laminar.Title$", ({
  jM: 1,
  ac: 1
}));
export { $d_Lio_github_nguyenyou_ui5_webcomponents_laminar_Title$ as $d_Lio_github_nguyenyou_ui5_webcomponents_laminar_Title$ };
var $n_Lio_github_nguyenyou_ui5_webcomponents_laminar_Title$;
function $m_Lio_github_nguyenyou_ui5_webcomponents_laminar_Title$() {
  if ((!$n_Lio_github_nguyenyou_ui5_webcomponents_laminar_Title$)) {
    $n_Lio_github_nguyenyou_ui5_webcomponents_laminar_Title$ = new $c_Lio_github_nguyenyou_ui5_webcomponents_laminar_Title$();
  }
  return $n_Lio_github_nguyenyou_ui5_webcomponents_laminar_Title$;
}
export { $m_Lio_github_nguyenyou_ui5_webcomponents_laminar_Title$ as $m_Lio_github_nguyenyou_ui5_webcomponents_laminar_Title$ };
